import React, { useState } from "react";
import { StaticQuery, graphql } from "gatsby";

import CloseIcon from "../../images/icons/close.inline.svg";
import MenuToggle from "../../images/icons/menu.inline.svg";
import NavbarLinks from "./navbarLinks.js";

const Navbar = ({ siteTitle, setShowModal }) => {
  const [isExpanded, toggleExpansion] = useState(false);

  return (
    <StaticQuery
      query={graphql`
        query {
          allWpMenuItem(
            filter: { locations: { eq: PRIMARY_MENU }, parentId: { eq: null } }
            sort: { order: ASC, fields: order }
          ) {
            edges {
              node {
                id
                parentId
                label
                url
                target
                order
                childItems {
                  nodes {
                    id
                    parentId
                    label
                    url
                    target
                    order
                  }
                }
              }
            }
          }
          wp {
            tenjinSettings {
              acf {
                stacksMenuLabel
                destinationsMenuLabel
                sourcesMenuLabel
                trainingMenuLabel
                tutorialMenuLabel
                analysesMenuLabel
                stacksPage {
                  ... on WpPage {
                    id
                    seo {
                      canonical
                      cornerstone
                      focuskw
                      fullHead
                      metaDesc
                      metaKeywords
                      metaRobotsNofollow
                      metaRobotsNoindex
                      opengraphAuthor
                      opengraphDescription
                      opengraphModifiedTime
                      opengraphPublishedTime
                      opengraphPublisher
                      opengraphSiteName
                      opengraphTitle
                      opengraphType
                      opengraphUrl
                      readingTime
                      title
                      twitterDescription
                      twitterTitle
                    }
                  }
                }
                destinationsPage {
                  ... on WpPage {
                    id
                    title
                  }
                }
                sourcesPage {
                  ... on WpPage {
                    id
                    title
                  }
                }
                analysesPage {
                  ... on WpPage {
                    id
                    title
                  }
                }
                trainingPage {
                  ... on WpPage {
                    id
                    title
                  }
                }
                tutorialPage {
                  ... on WpPage {
                    id
                    title
                  }
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        const stackPages = {
          stacks: data.wp.tenjinSettings.acf.stacksPage,
          destinations: data.wp.tenjinSettings.acf.destinationsPage,
          sources: data.wp.tenjinSettings.acf.sourcesPage,
          analyses: data.wp.tenjinSettings.acf.analysesPage,
          training: data.wp.tenjinSettings.acf.trainingPage,
          tutorial: data.wp.tenjinSettings.acf.tutorialPage,
        };

        const stackMenuLabels = {
          stacks: data.wp.tenjinSettings.acf.stacksMenuLabel,
          destinations: data.wp.tenjinSettings.acf.destinationsMenuLabel,
          sources: data.wp.tenjinSettings.acf.sourcesMenuLabel,
          analyses: data.wp.tenjinSettings.acf.analysesMenuLabel,
          training: data.wp.tenjinSettings.acf.trainingMenuLabel,
          tutorial: data.wp.tenjinSettings.acf.tutorialMenuLabel,
        };

        return (
          <nav className="absolute top-0 bottom-0 left-0 z-50 flex items-center lg:relative lg:inset-auto">
            {!isExpanded && (
              <button
                onClick={() => toggleExpansion(!isExpanded)}
                className="mt-6 lg:hidden"
                aria-label="Toggle Menu"
              >
                <MenuToggle className="text-black fill-current i-menu-toggle" />
              </button>
            )}
            <div
              className={`${
                isExpanded ? `fixed` : `hidden`
              } w-full left-0 top-0 h-screen w-screen  
                        lg:flex lg:items-center lg:w-auto lg:h-auto`}
            >
              <button
                onClick={() => toggleExpansion(!isExpanded)}
                className="absolute left-0 z-20 mt-4 ml-6 top-6 lg:hidden"
                aria-label="Close Menu"
              >
                <CloseIcon className="w-4 h-4 text-black fill-current" />
              </button>
              <div style={{ zIndex: 100 }}>
                <NavbarLinks {...{ stackPages, stackMenuLabels, data, setShowModal }} />
              </div>
            </div>
          </nav>
        );
      }}
    />
  );
};

export default Navbar;
